// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-pen.js';

import { paths } from '../generated/file-pen';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-pen', Original, paths);
